import { VueModule } from '@Foundation/utilities';
import ProductViewer from '@Feature/ProductViewer/code/Scripts/components/product-viewer';
import ColorVariant from '@Feature/ColorVariant/code/Scripts/components/color-variant';
import VolumeVariant from '@Feature/VolumeVariant/code/Scripts/components/volume-variant.vue';
import buynow from '@Feature/buynow/code/Scripts/components/buynow.vue';
import addtocart from '@Feature/addtocart/code/Scripts/components/addtocart.vue';
import ProductViewerV2 from '@Feature/ProductViewer-V2/code/Scripts/components/product-viewer-v2';
import ProductDescription from '@Feature/ProductDescription/code/Scripts/components/product-description';
import ProductDescriptionHead from '@Feature/ProductDescription/code/Scripts/components/product-description-head.vue';
import ProductDescriptionVariant from '@Feature/ProductDescription/code/Scripts/components/product-description-variant.vue';
import ColorVariantV2 from '@Feature/ColorVariant-V2/code/Scripts/components/color-variant-v2';
import VolumeVariantV2 from '@Feature/VolumeVariant-V2/code/Scripts/components/volume-variant-v2';
import ScrollRating from'@Feature/ScrollRating/code/Scripts/components/scroll-rating'

export default VueModule({
  components: {
    ProductViewer,
    ColorVariant,
    VolumeVariant,
    buynow,
    addtocart,
    ProductViewerV2,
    ProductDescription,
    ProductDescriptionHead,
    ProductDescriptionVariant,
    ColorVariantV2,
    VolumeVariantV2,
    ScrollRating,
  }
});
